import React from 'react'
import Modal from '../../component/Inc/Modal'
function PopPolicyPoint(props) {
  const {open, close} = props
  return (
    <Modal open={open} close={close} type="pop_point">
      <h2 className="pop_tit">
        <span className="com_blue_txt">+</span> 포인트 정책
      </h2>
      <div className="content_container scroll">
        <table className="com_board_list type_bg_blue">
          <colgroup>
            <col width="100" />
            <col width="150" />
            <col width="220" />
            <col width="220" />
          </colgroup>
          <thead>
            <tr>
              <th>항목</th>
              <th>세부항목</th>
              <th>구분</th>
              <th>추가 포인트</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="bg_col td_noBorder" rowspan="2">
                교관활동
              </td>
              <td>정기교육</td>
              <td>정기교육 교관으로 교사를 교육</td>
              <td className="td_left com_blue_txt">시간당 : +1</td>
            </tr>
            <tr>
              <td>비정기교육</td>
              <td>비정기교육 교관으로 교사를 교육</td>
              <td className="td_left com_blue_txt">시간당 : +1</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowspan="2">
                교육참여
              </td>
              <td>정기교육</td>
              <td>아카데미 교육(필수/의무교육 제외)</td>
              <td className="td_left com_blue_txt">1회당 : +2</td>
            </tr>
            <tr>
              <td>비정기교육</td>
              <td>수시 영역 관련 교육, 기획교육</td>
              <td className="td_left com_blue_txt">1회당 : +2</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder">셀활동 참여</td>
              <td>셀모임</td>
              <td>각 영역별 셀모임 참여</td>
              <td className="td_left com_blue_txt">1회당 : +3</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowspan="2">
                수업배정 기여
              </td>
              <td>비정기여</td>
              <td>2기/3기 인계 또는 다수 인계 수업</td>
              <td className="td_left com_blue_txt">+8</td>
            </tr>
            <tr>
              <td>교사소개</td>
              <td>교사를 소개하여 면접에 합격한 경우</td>
              <td className="td_left com_blue_txt">1명당 : +10</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowspan="4">
                연구활동
              </td>
              <td>교재제작 검토</td>
              <td>교재 제작 및 검토 참여</td>
              <td className="td_left com_blue_txt">기여도에 따라 : 1 ~ +20</td>
            </tr>
            <tr>
              <td>기출분석</td>
              <td>수능 및 모의고사 문항 분석</td>
              <td className="td_left com_blue_txt">과목당 : +2</td>
            </tr>
            <tr>
              <td>오류검토</td>
              <td>내/외부 교재 오류와 오차 보고</td>
              <td className="td_left com_blue_txt">1개당 : +1</td>
            </tr>
            <tr>
              <td>프로젝트 수행</td>
              <td>회사가 필요로하는 과업의 수행 시</td>
              <td className="td_left com_blue_txt">기여도에 따라 : 1 ~ +20</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowspan="2">
                이벤트
              </td>
              <td>캠페인</td>
              <td>각종 캠페인 및 홍보활동</td>
              <td className="td_left com_blue_txt">기여도에 따라 : 1 ~ +20</td>
            </tr>
            <tr>
              <td>기타 이벤트</td>
              <td>기타 회사가 인정하는 경우</td>
              <td className="td_left com_blue_txt">기여도에 따라 : 1 ~ +20</td>
            </tr>
          </tbody>
        </table>
        <h2 className="pop_tit">
          <span className="com_red_txt">-</span> 포인트 정책
        </h2>
        <table className="com_board_list type_bg_red">
          <colgroup>
            <col width="100" />
            <col width="150" />
            <col width="220" />
            <col width="220" />
          </colgroup>
          <thead>
            <tr>
              <th>항목</th>
              <th>세부항목</th>
              <th>구분</th>
              <th>차감 포인트</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="bg_col td_noBorder" rowspan="2">
                기본항목
              </td>
              <td>수업평가서</td>
              <td>월 1회</td>

              <td className="td_left com_red_txt">
                기간외제출 : -1
                <br />
                미제출 : -1
              </td>
            </tr>

            <tr>
              <td>상담결과서</td>
              <td>회사지정</td>

              <td className="td_left com_red_txt">미제출 : -1</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowspan="4">
                회사활동
              </td>
              <td>회사공식활동</td>
              <td>회사지정</td>

              <td className="td_left com_red_txt">
                사유서 제출 : -10
                <br />
                사유서 미제출 : -20
              </td>
            </tr>
            <tr>
              <td>입사자 재교육</td>
              <td>평가점수 미달 시</td>

              <td className="td_left com_red_txt">
                사유서 제출 : -10
                <br />
                사유서 미제출 : -20
              </td>
            </tr>
            <tr>
              <td>C/S 교육</td>
              <td>C/S 이슈 발생 시</td>

              <td className="td_left com_red_txt">무단불참 : -30</td>
            </tr>
            <tr>
              <td>보수교육</td>
              <td>기타 재교육 필요 시</td>

              <td className="td_left com_red_txt">재차 무단불참 : -50</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowSpan={2}>
                계약서 위반
              </td>
              <td>개인관리전환</td>
              <td>불법 개인관리전환 적발 시</td>

              <td className="td_left com_red_txt"></td>
            </tr>
            <tr>
              <td>수업 체크</td>
              <td>9일 이상 체크 지연</td>

              <td className="td_left com_red_txt">-7</td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder">계약서 위반</td>
              <td>기타 사항</td>
              <td>회사 지정</td>

              <td className="td_left com_red_txt"></td>
            </tr>
            <tr>
              <td className="bg_col td_noBorder" rowSpan={4}>
              계약서 위반
              </td>
              <td>첫 수업 실패</td>
              <td></td>

              <td className="td_left com_red_txt">-7</td>
            </tr>
            <tr>
              <td>인계</td>
              <td>
                <br />
                <br />
              </td>
              <td className="td_left com_red_txt">
                인계1 : -8
                <br />
                인계2 : -16
                <br />
                인계3 : -32 – 누적수업 X 타임수
              </td>
            </tr>

            <tr>
              <td>중단</td>
              <td>
                <br />
                <br />
              </td>
              <td className="td_left com_red_txt">
                중단1 : -8 <br />
                중단2 : -16 <br />
                중단3 : -32 – 누적수업 X 타임수
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs" onClick={close}>
          확인
        </button>
      </div>
    </Modal>
  )
}

export default PopPolicyPoint
